import { render } from "./dialogAi.vue?vue&type=template&id=47ff48d8&scoped=true"
import script from "./dialogAi.vue?vue&type=script&lang=js"
export * from "./dialogAi.vue?vue&type=script&lang=js"

import "./dialogAi.vue?vue&type=style&index=0&id=47ff48d8&scoped=true&lang=scss"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ff48d8"]])

export default __exports__